module.exports = __webpack_public_path__ + "img/avnon-2.bed70f2e.jpg";